import type { RecordView } from '@kit/sync/types/record-view';
import { completionPatch } from '../helpers/completion-patch';
import type { Task } from '../schemas/task';
import { patchTask } from './patch-task';

/** Mark done (or reschedule a periodic check); returns the patch applied. */
export async function completeTask(view: RecordView<Task>): Promise<Partial<Task>> {
  const patch = completionPatch(view.data);
  await patchTask(view.id, patch);
  return patch;
}
